import { Format } from "shared-ts/classes/timestamp"
import { UUID } from "shared-ts/classes/uuid"
import { createColumnHelper } from "shared-web/components/composite/TableV2/createColumnHelper"
import {
  TableCellHeight,
  TableCellWidth,
} from "shared-web/components/composite/TableV2/TableCell"
import { useTable } from "shared-web/components/composite/TableV2/useTable"

import { getTransactionDetails } from "features/pos/customers/ReceivablesHistoryPanel/ReceivablesHistoryPanel"

import { ReceivableHistoryItem } from "./receivableHistory.adapter"
import { useReceivableHistoryData } from "../Credit/data/useCreditHistoryData"

interface useReceivableHistoryTableProps {
  ledgerEntryId: UUID
}
export function useReceivableHistoryTable({
  ledgerEntryId,
}: useReceivableHistoryTableProps) {
  const { data, isLoading, isError } = useReceivableHistoryData(ledgerEntryId)
  const { tableProps } = useTable({
    data: data?.historyItems ?? [],
    columns: historyTableColumns(),
    cellHeight: TableCellHeight.Small,
    extractRowKey: (row) => UUID.idString(row.ledgerEntryId),
    isLoading,
    isError,
  })
  return {
    tableProps,
    receivable: data?.receivable,
  }
}

const colHelper = createColumnHelper<ReceivableHistoryItem>()

export function historyTableColumns() {
  return [
    colHelper.date(({ date }) => date, Format.DATE, {
      title: "Date",
      width: TableCellWidth.Medium,
    }),
    colHelper.id({
      accessorFn: ({ identifier }) => identifier,
      chipColor: ({ transaction }) =>
        getTransactionDetails(transaction.type).color,
      path: ({ transaction }) =>
        getTransactionDetails(transaction.type, transaction.id).href,
    }),
    colHelper.accessor(
      ({ transaction }) => getTransactionDetails(transaction.type).type,
      {
        title: "Type",
        width: TableCellWidth.Medium,
      }
    ),
    colHelper.money(
      ({ balanceDelta }) => {
        return balanceDelta.isPositive() ? balanceDelta : undefined
      },
      {
        title: "Debit",
        width: TableCellWidth.Small,
      }
    ),
    colHelper.money(
      ({ balanceDelta }) => {
        return balanceDelta.isNegative() ? balanceDelta.negative() : undefined
      },
      {
        title: "Credit",
        width: TableCellWidth.Small,
      }
    ),
    colHelper.money(({ runningBalance }) => runningBalance, {
      title: "Running",
      width: TableCellWidth.Small,
    }),
  ]
}
